/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What a one-shot MULTIPLIER outcome applies to
 * @export
 */
export const StreakMultiplierAppliesTo = {
    XP: 'XP',
    FUEL: 'FUEL',
    ENTRIES: 'ENTRIES',
    HUB_POINTS: 'HUB_POINTS',
    ALL: 'ALL'
} as const;
export type StreakMultiplierAppliesTo = typeof StreakMultiplierAppliesTo[keyof typeof StreakMultiplierAppliesTo];


export function instanceOfStreakMultiplierAppliesTo(value: any): boolean {
    for (const key in StreakMultiplierAppliesTo) {
        if (Object.prototype.hasOwnProperty.call(StreakMultiplierAppliesTo, key)) {
            if (StreakMultiplierAppliesTo[key as keyof typeof StreakMultiplierAppliesTo] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakMultiplierAppliesToFromJSON(json: any): StreakMultiplierAppliesTo {
    return StreakMultiplierAppliesToFromJSONTyped(json, false);
}

export function StreakMultiplierAppliesToFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakMultiplierAppliesTo {
    return json as StreakMultiplierAppliesTo;
}

export function StreakMultiplierAppliesToToJSON(value?: StreakMultiplierAppliesTo | null): any {
    return value as any;
}

export function StreakMultiplierAppliesToToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakMultiplierAppliesTo {
    return value as StreakMultiplierAppliesTo;
}

